var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSignUpApple32 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.98 15.023c-.011-1.865.834-3.27 2.54-4.307-.954-1.367-2.398-2.119-4.301-2.264-1.802-.142-3.774 1.05-4.496 1.05-.763 0-2.507-1-3.88-1C9.011 8.545 6 10.76 6 15.266q0 1.998.73 4.124c.65 1.865 2.997 6.434 5.444 6.36 1.28-.03 2.185-.908 3.85-.908 1.616 0 2.453.908 3.88.908 2.47-.035 4.591-4.19 5.21-6.06-3.312-1.56-3.134-4.571-3.134-4.667m-2.874-8.34c1.386-1.646 1.26-3.144 1.22-3.683-1.226.071-2.642.834-3.449 1.772-.888 1.006-1.41 2.25-1.298 3.653 1.323.101 2.531-.58 3.527-1.742"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignUpApple32);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };